module.exports = "<div id=\"person-activities-graph\" class=\"graph\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/dashboard/person-activities-graph.component.html
// module id = 1412
// module chunks = 1